(function () {
  'use strict';

  var SELECTORS = {
    drawer: '[data-pm-drawer]',
    overlay: '[data-pm-drawer-overlay]'
  };

  function all(selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  }

  function focusable(container) {
    return all('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', container)
      .filter(function (item) { return item.offsetParent !== null; });
  }

  function trapTab(event, container) {
    if (event.key !== 'Tab' || !container) return;
    var items = focusable(container);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function syncBodyLock() {
    var hasOpenPanel = document.querySelector(SELECTORS.drawer + '.is-open, .js-box-search.active, .js-minicart.active');
    document.body.classList.toggle('pm-drawer-open', Boolean(hasOpenPanel));
  }

  function setDrawerState(drawer, open, trigger) {
    if (!drawer) return;
    var overlay = document.querySelector(SELECTORS.overlay);
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) drawer.removeAttribute('inert');
    else drawer.setAttribute('inert', '');
    if (overlay) overlay.classList.toggle('is-open', open);
    if (drawer.id) {
      all('[aria-controls="' + drawer.id + '"]').forEach(function (control) {
        control.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    syncBodyLock();
    if (open) {
      drawer.dataset.pmReturnFocus = trigger && trigger.id ? trigger.id : '';
      var items = focusable(drawer);
      if (items.length) items[0].focus();
    } else {
      var returnFocus = drawer.dataset.pmReturnFocus && document.getElementById(drawer.dataset.pmReturnFocus);
      if (returnFocus) returnFocus.focus();
    }
  }

  function closeAllDrawers() {
    all(SELECTORS.drawer + '.is-open').forEach(function (drawer) {
      setDrawerState(drawer, false);
    });
  }

  function initDrawers(context) {
    all('[data-pm-drawer-open]', context).forEach(function (trigger) {
      if (trigger.dataset.pmBound) return;
      trigger.dataset.pmBound = 'true';
      trigger.addEventListener('click', function () {
        closeAllDrawers();
        setDrawerState(document.getElementById(trigger.getAttribute('aria-controls')), true, trigger);
      });
    });
    all('[data-pm-drawer-close]', context).forEach(function (trigger) {
      if (trigger.dataset.pmBound) return;
      trigger.dataset.pmBound = 'true';
      trigger.addEventListener('click', function () {
        setDrawerState(trigger.closest(SELECTORS.drawer), false);
      });
    });
    var overlay = document.querySelector(SELECTORS.overlay);
    if (overlay && !overlay.dataset.pmBound) {
      overlay.dataset.pmBound = 'true';
      overlay.addEventListener('click', closeAllDrawers);
    }
  }

  function initHeader() {
    var header = document.querySelector('[data-pm-header]');
    if (!header || header.dataset.pmHeaderBound) return;
    header.dataset.pmHeaderBound = 'true';
    var lastY = Math.max(0, window.scrollY);
    var ticking = false;
    var update = function () {
      var currentY = Math.max(0, window.scrollY);
      var delta = currentY - lastY;
      header.classList.toggle('is-scrolled', currentY > 12);
      if (!document.body.classList.contains('pm-drawer-open')) {
        if (currentY > 150 && delta > 5) header.classList.add('is-hidden');
        if (currentY < 90 || delta < -5) header.classList.remove('is-hidden');
      }
      lastY = currentY;
      ticking = false;
    };
    var requestUpdate = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };
    requestUpdate();
    window.addEventListener('scroll', requestUpdate, { passive: true });

    var announcement = document.querySelector('[data-pm-announcement]');
    if (!announcement || announcement.dataset.rotate !== 'true') return;
    var messages = all('[data-pm-announcement-message]', announcement);
    if (messages.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var current = 0;
    window.setInterval(function () {
      messages[current].classList.remove('is-active');
      current = (current + 1) % messages.length;
      messages[current].classList.add('is-active');
    }, Number(announcement.dataset.interval || 5000));
  }

  function closeSearch() {
    var panel = document.querySelector('.js-box-search');
    var root = panel && panel.closest('.search-full-destop');
    var backdrop = document.querySelector('.bg_search_box');
    if (panel) {
      panel.classList.remove('active');
      panel.setAttribute('aria-hidden', 'true');
    }
    if (root) {
      root.classList.remove('is-active');
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('inert', '');
    }
    if (backdrop) backdrop.classList.remove('active');
    all('.js-search-destop').forEach(function (trigger) { trigger.setAttribute('aria-expanded', 'false'); });
    document.body.classList.remove('activedestop');
    syncBodyLock();
  }

  function closeMinicart() {
    var cart = document.querySelector('.js-minicart');
    var backdrop = document.querySelector('.bg-minicart');
    if (cart) {
      cart.classList.remove('active');
      cart.setAttribute('aria-hidden', 'true');
      cart.setAttribute('inert', '');
    }
    if (backdrop) backdrop.classList.remove('active');
    all('.js-call-minicart').forEach(function (trigger) { trigger.setAttribute('aria-expanded', 'false'); });
    syncBodyLock();
  }

  function openSearch() {
    var panel = document.querySelector('.js-box-search');
    var root = panel && panel.closest('.search-full-destop');
    var backdrop = document.querySelector('.bg_search_box');
    closeAllDrawers();
    closeMinicart();
    if (panel) {
      panel.classList.add('active');
      panel.setAttribute('aria-hidden', 'false');
    }
    if (root) {
      root.classList.add('is-active');
      root.setAttribute('aria-hidden', 'false');
      root.removeAttribute('inert');
    }
    if (backdrop) backdrop.classList.add('active');
    all('.js-search-destop').forEach(function (trigger) { trigger.setAttribute('aria-expanded', 'true'); });
    document.body.classList.add('activedestop');
    syncBodyLock();
    window.setTimeout(function () {
      var input = panel && panel.querySelector('input[type="search"]');
      if (input) input.focus();
    }, 50);
  }

  function openMinicart() {
    var cart = document.querySelector('.js-minicart');
    var backdrop = document.querySelector('.bg-minicart');
    closeAllDrawers();
    closeSearch();
    if (cart) {
      cart.classList.add('active');
      cart.setAttribute('aria-hidden', 'false');
      cart.removeAttribute('inert');
    }
    if (backdrop) backdrop.classList.add('active');
    all('.js-call-minicart').forEach(function (trigger) { trigger.setAttribute('aria-expanded', 'true'); });
    syncBodyLock();
    window.setTimeout(function () {
      var closeButton = cart && cart.querySelector('.close-mini-cart');
      if (closeButton) closeButton.focus();
    }, 50);
  }

  function initOverlayBridges() {
    if (document.documentElement.dataset.pmOverlayBound) return;
    document.documentElement.dataset.pmOverlayBound = 'true';
    document.addEventListener('click', function (event) {
      var searchTrigger = event.target.closest('.js-search-destop');
      if (searchTrigger) {
        event.preventDefault();
        openSearch();
        return;
      }
      var cartTrigger = event.target.closest('.js-call-minicart');
      if (cartTrigger) {
        event.preventDefault();
        openMinicart();
        return;
      }
      if (event.target.closest('.js-drawer-close') || event.target.closest('.bg_search_box')) closeSearch();
      if (event.target.closest('.close-mini-cart') || event.target.closest('.bg-minicart')) closeMinicart();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeSearch();
        closeMinicart();
        return;
      }
      trapTab(event, document.querySelector('.search-full-destop.is-active, .js-minicart.active'));
    });
  }

  function initSort(context) {
    all('[data-pm-sort]', context).forEach(function (select) {
      if (select.dataset.pmBound) return;
      select.dataset.pmBound = 'true';
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        window.location.assign(url.toString());
      });
    });
  }

  function initSecondaryCardImages(context) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    all('.pm-product-card', context).forEach(function (card) {
      var image = card.querySelector('[data-pm-secondary-image]');
      if (!image || image.dataset.pmSecondaryBound) return;
      image.dataset.pmSecondaryBound = 'true';
      var load = function () {
        if (image.dataset.pmSecondaryLoaded) return;
        image.dataset.pmSecondaryLoaded = 'true';
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        if (image.dataset.src) image.src = image.dataset.src;
        image.removeAttribute('data-srcset');
        image.removeAttribute('data-src');
      };
      card.addEventListener('pointerenter', load, { once: true, passive: true });
      card.addEventListener('focusin', load, { once: true });
    });
  }

  var revealObserver;
  var REVEAL_SELECTOR = [
    '.pm-section-heading',
    '.pm-category-card',
    '.pm-product-card',
    '.pm-editorial__media',
    '.pm-editorial__content',
    '.pm-campaign-card',
    '.pm-story__media',
    '.pm-story__content',
    '.pm-look__media',
    '.pm-look__content',
    '.pm-trust__item',
    '.pm-collection-index-card',
    '.pm-contact-card',
    '.pm-reviews__heading',
    '.pm-review-card',
    '.pm-footer__column'
  ].join(',');

  function reveal(element) {
    element.classList.add('is-visible');
    if (revealObserver) revealObserver.unobserve(element);
  }

  function initMotion(context) {
    if (!document.documentElement.classList.contains('pm-motion-capable')) {
      document.documentElement.classList.add('pm-page-entered');
      return;
    }
    if (!revealObserver && 'IntersectionObserver' in window) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) reveal(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    }

    all(REVEAL_SELECTOR, context).forEach(function (element) {
      if (element.dataset.pmRevealBound) return;
      element.dataset.pmRevealBound = 'true';
      element.classList.add('pm-reveal');
      if (element.matches('.pm-editorial__media, .pm-story__media, .pm-look__media')) element.classList.add('pm-reveal--media');
      if (element.matches('.pm-editorial__content, .pm-story__content, .pm-look__content')) element.classList.add('pm-reveal--content');
      var parent = element.parentElement;
      var index = parent ? Array.prototype.indexOf.call(parent.children, element) : 0;
      element.style.setProperty('--pm-reveal-delay', Math.min(Math.max(index, 0), 5) * 70 + 'ms');
      if (revealObserver) revealObserver.observe(element);
      else reveal(element);
    });
  }

  function init(context) {
    var scope = context || document;
    initDrawers(scope);
    initSort(scope);
    initSecondaryCardImages(scope);
    initMotion(scope);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initOverlayBridges();
    init(document);
    if (document.documentElement.classList.contains('pm-motion-capable')) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          document.documentElement.classList.add('pm-page-entered');
        });
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    var openDrawer = document.querySelector(SELECTORS.drawer + '.is-open');
    if (!openDrawer) return;
    if (event.key === 'Escape') {
      setDrawerState(openDrawer, false);
      return;
    }
    trapTab(event, openDrawer);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
